'use strict';

import React, { PropTypes } from 'react';
import ReactDOM from 'react-dom';

require('styles//Lyrics.css');

class LyricsComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      playing: false
    };
  }

  static propTypes = {
    channel: PropTypes.number.isRequired,
    track: PropTypes.string.isRequired
  };

  updateLyrics() {
    const url = this.props.channel === 333 ?
      '/data/sirens.html' : '/data/sirens_digital.html';
    fetch(url).then((response) => {
      response.text().then((lyrics) => {
        const container = ReactDOM.findDOMNode(this.refs.lyrics);
        container.innerHTML = lyrics;
      });
    });
  }

  componentDidMount() {
    this.updateLyrics();
  }

  componentWillReceiveProps() {
    this.updateLyrics();
  }

  toggleAudio() {
    const audio = ReactDOM.findDOMNode(this.refs.audio);
    if (audio.paused) {
      audio.play();
    }
  }

  render() {
    return (
      <div className="lyrics-component">
        <p>
          <a onClick={this.toggleAudio.bind(this)}>
            Play
          </a>
          <br />
          <br />
          <br />
          <br />
          <audio ref="audio" preload src={this.props.track}>
            Your browser does not support HTML5 audio
          </audio>
        </p>
        <p ref="lyrics"></p>
      </div>
    );
  }
}

LyricsComponent.displayName = 'LyricsComponent';

// Uncomment properties you need
// LyricsComponent.propTypes = {};
// LyricsComponent.defaultProps = {};

export default LyricsComponent;



// WEBPACK FOOTER //
// ./src/components/LyricsComponent.js